import React from "react";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";

// Images import
import img1 from "../../assets/images/Founder-image/founder.jpeg";
import img2 from "../../assets/images/Founder-image/1st.jpg";
import img3 from "../../assets/images/Founder-image/2nd.jpg";

const AttorneySection = () => {
  const COLORS = {
    bgPrimary: "#0B1C2D", // Deep Navy
    bgSecondary: "#13293D", // Slightly Lighter Navy
    gold: "#C6A75E", // Premium Gold
    textLight: "#EAEAEA",
  };

  const attorneys = [
    { name: "Arun Chaudhri", role: "Founder & Advocate", img: img1 },
    { name: "Adv. Simran Thakur", role: "Associate Advocate", img: img2 },
    { name: "Adv. Kiran Kumari", role: "Associate Advocate", img: img3 },
  ];

  const services = [
    {
      id: "01",
      title: "Individual Case",
      desc: "Personalized legal support ensuring thorough attention and protection of rights.",
      link: "/services/",
    },
    {
      id: "02",
      title: "Legal Protection",
      desc: "Safeguarding your rights with expert guidance and strategic solutions.",
      link: "/services/",
    },
    {
      id: "03",
      title: "Private Service",
      desc: "Trusted private legal services tailored to safeguard your specific interests.",
      link: "/services/",
    },
  ];

  return (
    <section className="py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* --- HEADER --- */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <div className="max-w-2xl">
            <span
              className="uppercase tracking-[0.5em] text-[10px] font-bold block mb-4"
              style={{ color: COLORS.gold }}
            >
              The Legal Minds
            </span>
            <h2 className="text-4xl md:text-6xl text-black font-bold tracking-tight leading-tight">
              Expert Attorneys <br />
              <span className=" font-light opacity-60">at Nyaysakti</span>
            </h2>
          </div>
          <div
            className="hidden md:block w-32 h-[1px] mb-4 opacity-30"
            style={{ backgroundColor: COLORS.gold }}
          ></div>
        </div>

        {/* --- ATTORNEY CARDS: GALLERY STYLE --- */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-32">
          {attorneys.map((lawyer, index) => (
            <div key={index} className="group relative">
              {/* Main Image Card */}
              <div className="relative overflow-hidden rounded-xl aspect-[3/4] shadow-2xl border border-white/5">
                <img
                  src={lawyer.img}
                  alt={lawyer.name}
                  className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-110 grayscale-0"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1C2D] via-transparent to-transparent opacity-80" />

                {/* Social Floating Bar */}
                <div className="absolute right-4 top-1/2 -translate-y-1/2 flex flex-col gap-3 translate-x-12 group-hover:translate-x-0 transition-transform duration-500">
                  {[
                    FaFacebookF,
                    FaSquareXTwitter,
                    FaLinkedinIn,
                    FaInstagram,
                  ].map((Icon, i) => (
                    <div
                      key={i}
                      className="p-3 bg-white/10 backdrop-blur-md rounded-full border border-white/10 text-white hover:bg-[#C6A75E] transition-colors cursor-pointer"
                    >
                      <Icon size={12} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Floating Info Plate */}
              <div
                className="absolute -bottom-6 left-6 right-6 p-6 rounded-xl border border-white/10 backdrop-blur-xl shadow-xl transition-all duration-500 group-hover:-translate-y-2"
                style={{ backgroundColor: `${COLORS.bgSecondary}ee` }}
              >
                <p
                  className="text-[9px] uppercase tracking-[0.3em] font-bold mb-1"
                  style={{ color: COLORS.gold }}
                >
                  {lawyer.role}
                </p>
                <h4 className="text-white text-lg font-bold tracking-wide">
                  {lawyer.name}
                </h4>
                <div
                  className="w-0 group-hover:w-full h-[1px] mt-3 transition-all duration-700"
                  style={{ backgroundColor: COLORS.gold }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* --- SERVICE HIGHLIGHTS: MASTER CARD STYLE --- */}
        <div
          className="rounded-2xl border border-white/5 overflow-hidden shadow-2xl"
          style={{ backgroundColor: COLORS.bgSecondary }}
        >
          <div className="grid lg:grid-cols-12">
            {/* Left Narrative */}
            <div className="lg:col-span-5 p-12 lg:p-20 flex flex-col justify-center border-b lg:border-b-0 lg:border-r border-white/5">
              <span
                className="text-[12px] font-black uppercase tracking-[0.5em] mb-6 block"
                style={{ color: COLORS.gold }}
              >
                Our Commitment
              </span>
              <h3 className="text-white text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8">
                Designed for <br />
                <span className=" font-light opacity-50">Everyone.</span>
              </h3>
              <p
                className="text-gray-300 text-base md:text-lg font-light leading-relaxed border-l-2 pl-6"
                style={{ borderColor: COLORS.gold }}
              >
                At Nyaysakti Law Firm, we believe that quality legal support
                should be accessible. With 19+ years of mastery, we simplify
                complex legalities.
              </p>
            </div>

            {/* Right Services List */}
            <div className="lg:col-span-7 divide-y divide-white/5">
              {services.map((item) => (
                <div
                  key={item.id}
                  className="p-10 group hover:bg-white/[0.02] transition-colors flex gap-8 items-center"
                >
                  {/* Highlighted Number */}
                  <span
                    className="text-5xl md:text-6xl font-serif italic opacity-20"
                    style={{
                      color: "white",
                      textShadow: "0 0 10px rgba(198,167,94,0.6)",
                    }}
                  >
                    {item.id}
                  </span>

                  {/* Content */}
                  <div className="flex-1">
                    <h5 className="text-white font-bold uppercase tracking-widest text-base md:text-lg mb-2 group-hover:text-[#C6A75E] transition-colors">
                      {item.title}
                    </h5>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-md">
                      {item.desc}
                    </p>
                  </div>

                  {/* Link Arrow */}
                  <a
                    href={item.link}
                    className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white group-hover:border-[#C6A75E] group-hover:text-[#C6A75E] transition-all"
                  >
                    →
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AttorneySection;
